import moment from 'moment';
import template from './range-date.template.html';

class RangeDateController {
  constructor($rootScope, gettextCatalog, dateUtil, appSettings) {
    'ngInject';
    this.dateUtil = dateUtil;
    this.$rootScope = $rootScope;
    this.appSettings = appSettings;

    this.timeRangePresets = [
      {
        value: 1,
        label: gettextCatalog.getString('24hrs'),
        tooltip: gettextCatalog.getString('Last 24 Hours')
      },
      {
        value: 7,
        label: gettextCatalog.getString('7d'),
        tooltip: gettextCatalog.getString('Last 7 Days')
      },
      {
        value: 30,
        label: gettextCatalog.getString('30d'),
        tooltip: gettextCatalog.getString('Last 30 Days')
      }
    ];

    this.datepickerFormat = 'M/d/yy';
    this.datepickerTimeFormat = 'M/d/yy h:mm a';
    this.startOpened = this.endOpened = false;
    this.invalidStartDate = this.invalidEndDate = false;
    this.locale = 'en';
    this.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    this.currentFormat = this.formats[1];
    this.timeSelected = false;
  }

  $onInit() {
    if (this.$rootScope.currentUser) {
      this.locale = this.$rootScope.currentUser.claims.data.language;
    }
    this.dateFormat = this.appSettings.GetDateFormat();
    this.setMinDate();
    this.setMaxDate();
  }

  setMinDate() {
    this.start = !this.startRang || this.startRang >= this.minDate ? this.minDate : this.startRange;
  }

  setMaxDate() {
    this.end = !this.endRange || this.endRange <= this.maxDate ? this.maxDate : this.endRange;
  }

  endChanged() {
    this.updateEndDate({
      endDate: this.endRange
    });
  }

  startChanged() {
    this.updateStartDate({
      startDate: this.startRange
    });
  }

  openStart() {
    this.startOpened = !this.startOpened;
  }

  openEnd() {
    this.endOpened = !this.endOpened;
  }

  showTime() {
    this.timeSelected = !this.timeSelected;
  }

  hasProperty() {
    return Object.keys(this.attr.selectedRange).length === 0;
  }
  //------------------------------------------------------------------------------------------------------------------------------------

  selectPreset(preset) {
    //update the start and end values
    $('#btn-1').blur();
    $('#btn-7').blur();
    $('#btn-30').blur();

    // Assigning the updated values
    this.startRange = moment()
      .subtract(preset.value, 'days')
      .startOf('minute')
      .toDate();
    this.endRange = moment()
      .startOf('minute')
      .toDate();
    this.maxDate = this.endRange();

    this.updateStartDate({
      startDate: this.startRange
    });
    this.updateEndDate({
      endDate: this.endRange
    });
  }

  // Boolean trigger to set 24h/7d/30d button to .active
  diffWithinParams(option) {
    if (moment(this.endRange, 'YYYY-MM-DD').isSame(this.maxDate, 'day')) {
      // Calculate the date from the option selected ( subtracting it from this.endRange)
      let dateFromOption = moment(this.endRange)
        .subtract(option.value, 'days')
        .toDate();
      // Returning is both the calulated date and startRange match up to the minute
      return moment(dateFromOption).isSame(this.startRange, 'minute');
    }
    return false;
  }
}

export const RangeDateComponent = {
  template,
  controller: RangeDateController,
  controllerAs: 'vm',
  bindings: {
    attr: '<',
    disabled: '<',
    showPresets: '<',
    showDates: '<',
    showTimes: '<',
    initDate: '<',
    startRange: '<?',
    endRange: '<?',
    minDate: '<?', // empty string for no min
    maxDate: '<?', // empty string for no max
    updateStartDate: '&',
    updateEndDate: '&'
  }
};
